import React from "react"
import { Link } from "react-router-dom"
import {ArrowRight, CheckCircle, Mail} from 'lucide-react'

export default function Affiliates() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-50 via-white to-blue-50 pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          {/* Coming Soon Badge */}
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-900 px-4 py-2 rounded-full text-sm font-medium mb-6">
            🔜 Affiliate Program Launching March 1, 2026
          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Affiliate Program
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Refer nurses and organizations you trust.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <div className="mb-12">
            <p className="text-lg text-gray-700 leading-relaxed">
              <strong>Coming March 1, 2026:</strong> Join our affiliate program and earn commissions for referring qualified nurses to international opportunities.
            </p>
          </div>

          {/* Why Become an Affiliate */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
              Why become an affiliate
            </h2>
            <div className="space-y-4">
              {[
                "Clear, transparent commission structure",
                "Support materials and tracking dashboard",
                "Global reach with regional guidance",
                "Compliance-first referral process",
                "Join a community of trusted partners"
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-0.5" />
                  <p className="text-lg text-gray-700">{item}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <Link
              to="/affiliates/apply"
              className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors shadow-lg hover:shadow-xl"
            >
              Express Interest
              <ArrowRight className="w-5 h-5" />
            </Link>
            <a
              href="mailto:hello@nursinghive.com"
              className="inline-flex items-center gap-2 bg-white text-gray-700 px-8 py-4 rounded-lg font-semibold border-2 border-gray-300 hover:border-teal-600 hover:text-teal-600 transition-colors"
            >
              <Mail className="w-5 h-5" />
              Contact Us
            </a>
          </div>

          {/* Timeline */}
          <div className="bg-gray-50 rounded-xl p-8 border border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Timeline:</h3>
            <ul className="space-y-2 text-gray-700">
              <li>• Interest collection now</li>
              <li>• Verification & onboarding in the lead-up to launch</li>
              <li>• Program goes live March 1, 2026</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  )
}
